export default "__VITE_ASSET__BKfgU0kM__"